import { createCustomAction } from 'typesafe-actions';
import { DISABLE_FORMSAVENOTIFIER_DEC, DISABLE_FORMSAVENOTIFIER_INC } from './constants';

export const disableFormsaveNotifierInc = createCustomAction(DISABLE_FORMSAVENOTIFIER_INC, (type) => {
    return () => ({ type });
});
export const disableFormsaveNotifierDec = createCustomAction(DISABLE_FORMSAVENOTIFIER_DEC, (type) => {
    return () => ({ type });
});
